export const FETCH_UPDATE_WASTE_REQUEST = 'FETCH_UPDATE_WASTE_REQUEST'
export const FETCH_UPDATE_WASTE_SUCCESS = 'FETCH_UPDATE_WASTE_SUCCESS'
export const FETCH_UPDATE_WASTE_FALUIRE = 'FETCH_UPDATE_WASTE_FALUIRE'
